import React from 'react';
import Navigation from './components/common/Navigation';
import Hero from './components/common/Hero';
import AboutSection from './components/sections/AboutSection';
import ServicesSection from './components/sections/ServicesSection';
import TechnologySection from './components/sections/TechnologySection';
import AdvantageSection from './components/sections/AdvantageSection';
import Footer from './components/sections/Footer';
import './styles/output.css';

const App: React.FC = () => {
  const scrollToSection = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F4] text-stone-800 selection:bg-serchon-gold selection:text-white">
      <Navigation scrollToSection={scrollToSection} />

      <main>
        <Hero />
        <AboutSection />
        <ServicesSection />
        <TechnologySection />
        <AdvantageSection />
      </main>

      <Footer />
    </div>
  );
};

export default App;
